import * as Immutable from "immutable";

export default class RatingModel extends Immutable.Record({
    comment_id: 0,
    timestamp: 0,
    weight: 0,
}) {

    public static mapArray(data: { [key: string]: any }[]): Immutable.List<RatingModel> {
        const items = [];
        for (let item of data) {
            items.push(new RatingModel(item));
        }
        return Immutable.List(items);
    }

    public getCommentId(): number {
        return this.get("comment_id");
    }

    public getTimestamp(): number {
        return this.get("timestamp");
    }

    public getWeight(): number {
        return this.get("weight");
    }

}